import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ElementApp } from './ElementApp'
import './styles/element.css'

const elementRootDomNode = document.getElementById('root')

if (!elementRootDomNode) {
  throw new Error('Element Mail: root DOM node not found. Check index.html for id="root"')
}

createRoot(elementRootDomNode).render(
  <StrictMode>
    <ElementApp />
  </StrictMode>
)
